module.exports = __webpack_public_path__ + "img/贵州轮胎LOGO.65977c79.png";